import { Box, CircularProgress } from '@mui/material';
import type React from 'react';

export type LoadingProps = {
  readonly className?: string;
};

const Loading: React.FC<LoadingProps> = ({ className }) => (
  <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center" className={className}>
    <CircularProgress />
  </Box>
);

export default Loading;
